import STORE from 'config/store.singleton';

const getState = STORE.getState.bind(STORE);

export default getState;
